<section class="sticky-wrapper">
  <button type="button" class="sticky-btn col-11" aria-label="Fai un Preventivo" (click)="onScrollToTop()">
    Fai un Preventivo
  <app-icon class="arrow-right" [name]="'ArrowRight'" [color]="'white'" [size]="24" aria-hidden="true" />
  </button>
</section>
